import { Tooltip } from '@mui/joy'

export default function OptionalTooltip({ title, show, children }) {
    return show ? <Tooltip title={title}>{children}</Tooltip> : children
}
